<template>
  <a-modal
    :title="title"
    :visible="open"
    :confirm-loading="submitLoading"
    @ok="submitForm"
    @cancel="cancel"
  >
    <a-form-model ref="form" :model="form" :rules="rules" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
      <a-form-model-item :label="$t('views.bizUser.vipPayment.isVip')" prop="isVip">
        <a-select v-model="form.isVip" :placeholder="$t('views.bizUser.vipPayment.isVipPlaceholder')" allow-clear>
          <a-select-option v-for="opt in isVipOptions" :key="opt.value" :value="opt.value">{{ opt.label }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('views.bizUser.vipPayment.paymentMethod')" prop="paymentMethod">
        <a-select v-model="form.paymentMethod" :placeholder="$t('views.bizUser.vipPayment.paymentMethodPlaceholder')" allow-clear>
          <a-select-option v-for="opt in paymentMethodOptions" :key="opt.value" :value="opt.value">{{ opt.label }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item v-if="form.paymentMethod === 1" :label="$t('views.bizUser.vipPayment.firstRate')" prop="firstModelRate">
        <a-input-number
          v-model="form.firstModelRate"
          :min="0.01"
          :max="1"
          :precision="2"
          :step="0.01"
          style="width: 100%"
          :placeholder="$t('views.bizUser.vipPayment.firstRatePlaceholder')"
        />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { updateVipPayment } from '@/api/biz/user'

export default {
  name: 'VipPaymentEdit',
  data () {
    return {
      open: false,
      submitLoading: false,
      form: {
        id: undefined,
        isVip: undefined,
        paymentMethod: undefined,
        firstModelRate: undefined
      }
    }
  },
  computed: {
    title () {
      return this.$t('views.bizUser.vipPayment.title')
    },
    isVipOptions () {
      return [
        { value: 0, label: this.$t('views.bizUser.option.notPro') },
        { value: 1, label: this.$t('views.bizUser.option.pro') }
      ]
    },
    paymentMethodOptions () {
      return [
        { value: 0, label: this.$t('views.bizUser.option.paymentFull') },
        { value: 1, label: this.$t('views.bizUser.option.paymentFirst') },
        { value: 2, label: this.$t('views.bizUser.option.paymentMonthly') }
      ]
    },
    rules () {
      const vm = this
      const validateFirstModelRate = (rule, value, callback) => {
        if (vm.form.paymentMethod !== 1) return callback()
        if (value === undefined || value === null || value === '') return callback(new Error(vm.$t('views.bizUser.vipPayment.err.firstRateRequired')))
        const num = Number(value)
        if (Number.isNaN(num)) return callback(new Error(vm.$t('views.bizUser.vipPayment.err.firstRateNumber')))
        if (num <= 0) return callback(new Error(vm.$t('views.bizUser.vipPayment.err.firstRateGt0')))
        if (num > 1) return callback(new Error(vm.$t('views.bizUser.vipPayment.err.firstRateLte1')))
        if (!/^\d+(\.\d{1,2})?$/.test(String(value))) return callback(new Error(vm.$t('views.bizUser.vipPayment.err.firstRateDecimal')))
        return callback()
      }
      return {
        isVip: [{ required: true, message: this.$t('views.bizUser.vipPayment.rule.selectIsVip'), trigger: 'change' }],
        paymentMethod: [{ required: true, message: this.$t('views.bizUser.vipPayment.rule.selectPayment'), trigger: 'change' }],
        firstModelRate: [{ validator: validateFirstModelRate, trigger: ['change', 'blur'] }]
      }
    }
  },
  methods: {
    show (record) {
      this.form = {
        id: record.id,
        isVip: record.isVip === true ? 1 : (record.isVip === false ? 0 : record.isVip),
        paymentMethod: record.paymentMethod,
        firstModelRate: record.firstModelRate
      }
      this.open = true
    },
    cancel () {
      this.open = false
      this.reset()
    },
    reset () {
      this.form = {
        id: undefined,
        isVip: undefined,
        paymentMethod: undefined,
        firstModelRate: undefined
      }
    },
    submitForm () {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.submitLoading = true
        updateVipPayment({
          id: this.form.id,
          isVip: this.form.isVip,
          paymentMethod: this.form.paymentMethod,
          firstModelRate: this.form.paymentMethod === 1 ? this.form.firstModelRate : undefined
        }).then(() => {
          this.$message.success(this.$t('views.bizUser.vipPayment.msg.success'), 3)
          this.open = false
          this.$emit('ok')
        }).finally(() => {
          this.submitLoading = false
        })
      })
    }
  }
}
</script>
